import { FC, useCallback } from 'react'
import * as isNumber from 'lodash/isNumber'
import PeergroupMenuItemContainer from 'components/features/pfm/PeergroupMenuItem/PeergroupMenuItemContainer'
import { SidebarGroups, SidebarGroupsTextSeparator, SidebarGroupsCreateCustomItem } from 'components/features/pfm/SidebarGroups/SidebarGroups'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { isMemberPremiumSelector } from 'selectors/globalSelectors'
import { relationsSelector, peersRelationIdSelector } from 'selectors/peergroupSelectors'
import { openSubscriptionPageActionCreator } from 'actions/floatingPanesActions'
import { destroy } from 'redux-form'
import { FORM_CREATE_CUSTOM_PEER_GROUP } from 'constants/forms'
import { showPeergroupCreateFormActionCreator } from 'actions/sidebarActions'
import { PremiumOnlyIcon } from 'components/features/pfm/PremiumOnlyIcon/PremiumOnlyIcon'
import styles from 'components/features/pfm/Peergroups/Peergroups.styl'

type PeergroupsProps = {

}

export const Peergroups: FC<PeergroupsProps> = (props) => {
  const {} = props

  const relations = useStoreSelector(relationsSelector)
  const peersRelationId = useStoreSelector(peersRelationIdSelector)

  const otherRelationIds = relations.allKeys.filter((id) => id !== peersRelationId)

  const isMemberPremium = useStoreSelector(isMemberPremiumSelector)

  const otherPeergroupsContainers = otherRelationIds.map((identifier) => (
    <PeergroupMenuItemContainer relationId={ identifier } key={ identifier } />
  ))

  const dispatch = useStoreDispatch()
  const handleCreateGroupClick = useCallback(() => {
    if (!isMemberPremium) {
      dispatch(openSubscriptionPageActionCreator())
      return
    }

    dispatch(destroy(FORM_CREATE_CUSTOM_PEER_GROUP))
    dispatch(showPeergroupCreateFormActionCreator())
  }, [dispatch, isMemberPremium])

  return (
    <SidebarGroups>
      <PeergroupMenuItemContainer relationId='member' />
      <SidebarGroupsTextSeparator>You are comparing to</SidebarGroupsTextSeparator>
      { isNumber(peersRelationId) && (
        <PeergroupMenuItemContainer relationId={ peersRelationId } />
      )}
      { otherPeergroupsContainers }
      <SidebarGroupsCreateCustomItem onClick={ handleCreateGroupClick }>
        <div className={ styles.addItem }>
          Add Custom Group
          <PremiumOnlyIcon isBlocked={ !isMemberPremium } />
        </div>
      </SidebarGroupsCreateCustomItem>
    </SidebarGroups>
  )
}
